import {injectReducer} from '../../store/reducers'
import {isLoggedIn} from '../../utils/auth'
import {loadOrderCaptureByRefsReducer, orderCaptureFormReducer} from './modules/OrderCapturePrint'

export default (store) => ({
  path: 'order-capture-print/:orderCaptureRefs',
  onEnter: isLoggedIn(store),
  isPrintView: true,
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      const OrderCapturePrint = require('./containers/OrderCapturePrint').default
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, {key: 'orderCaptureByRefs', reducer: loadOrderCaptureByRefsReducer})
      injectReducer(store, {key: 'orderCaptureForm', reducer: orderCaptureFormReducer})

      /*  Return getComponent   */
      cb(null, OrderCapturePrint)

      /* Webpack named bundle   */
    }, 'orderCapturePrint')
  }
})



// WEBPACK FOOTER //
// ./src/routes/OrderCapturePrint/index.js